import { WebglClient } from './webglClient';

export class Webgl2020ResourcesLoader {
    public static preloadWebglBuild() {
        this.getWebglResources().forEach((resource) => {
            $.get(resource);
        });
    }

    public static getWebglResources() {
        const resources = [
            `${window.app.webglBaseUrl}Build/${WebglClient.getBuildJsonFilename()}.loader.js`,
            `${window.app.webglBaseUrl}Build/${WebglClient.getBuildJsonFilename()}.framework.js`,
            `${window.app.webglBaseUrl}Build/${WebglClient.getBuildJsonFilename()}.wasm`,
            `${window.app.webglBaseUrl}Build/${WebglClient.getBuildJsonFilename()}.data`
        ];
        return resources;
    }
}
